import Loadable from 'react-loadable'
import Loading from '../../components/Loading/Loading'

const Login = Loadable({
  loader: () => import('./containers/LoginContainer'),
  loading: Loading,
})

export default {
  path: '/login',
  component: Login,
}



// WEBPACK FOOTER //
// ./src/routes/login/index.js